<div class="messages-container">
  <div class="content">
    <div class="header-top">
      <h1 class="header-top__heading">
        <div id="title">Messages</div>
      </h1>
    </div>
    <div class="messages__content">
      <div class="messages__view-area">
        <div #scrollable class="messages__data">
          @for (message of messages(); track message.messageNumber) {
            <app-message
              [message]="message"
              (downloadAttachment)="getAttachment(message, $event)"
              (deleteAttachment)="requestDeleteAttachment(message, $event)">
            </app-message>
          }

          @if (dataEmpty()) {
            <div class="empty">
              There are no messages to display
            </div>
          }

          @if (dataLoading()) {
            <app-loading-animation></app-loading-animation>
          }
        </div>
      </div>
    </div>
  </div>
</div>
<app-message-input-bar [isLoading]="dataLoading()" (messageSent)="messageSend($event)"
  (messagesRefreshed)="refreshConversation()"
  (attachmentError)="handleErrorEvent($event)">
</app-message-input-bar>
<app-confirm-dialog
  [isOpen]="pendingDeleteAttachment() !== null"
  [message]="'Are you sure you want to remove \'' + (pendingDeleteAttachment()?.attachment?.filename ?? '') + '\'?'"
  confirmLabel="Remove"
  cancelLabel="Cancel"
  (confirmed)="onConfirmDeleteAttachment()"
  (cancelled)="onCancelDeleteAttachment()">
</app-confirm-dialog>
